import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';

/**
 * GetFavoriteProducts Input Action
 */
export class GetFavoriteProductsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetFavoriteProducts`;
    public getCacheObjectType = () => 'GetFavoriteProducts';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetFavoriteProductsData {
    Products: string[];
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetFavoriteProductsInput();
};

async function action(_: GetFavoriteProductsInput, ctx: Msdyn365.IActionContext): Promise<IGetFavoriteProductsData> {
    ensureAuthenticated(ctx);

    const response = await Msdyn365.sendRequest<IGetFavoriteProductsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetFavoriteProducts`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    return response.data.Products ? { Products: response.data.Products } : { Products: [] };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetFavoriteProductsData>>action,
    id: 'GetFavoriteProducts',
    input: createInput
});
